import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    scroll-padding-top: 80px;
  }

  body {
    font-family: ${props => props.theme.fonts.body};
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text};
    overflow-x: hidden;
    line-height: 1.7;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /* Custom Scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.background};
  }
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.primary};
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.primaryLight};
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul, ol {
    list-style: none;
  }

  button, input, textarea {
    font-family: inherit;
    border: none;
    outline: none;
  }

  img {
    max-width: 100%;
    display: block;
  }

  ::selection {
    background: ${props => props.theme.colors.primary};
    color: white;
  }

  .container {
    width: 92%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
  }

  section {
    padding: ${props => props.theme.spacing.section} 0;
    position: relative;
    overflow-x: hidden;

    @media (max-width: ${props => props.theme.breakpoints.md}) {
      padding: ${props => props.theme.spacing.sectionMobile} 0;
    }
    @media (max-width: ${props => props.theme.breakpoints.sm}) {
      padding: 50px 0;
    }
  }
`;

export default GlobalStyle;
